import React from "react";

export const Inovation = (props) => {
  return (
    <div id="inovation">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/cell.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="inovation-text">
              <h2>Levamos inovação também para os profissionais da saúde</h2>
              <p>{props.data ? props.data.paragraph : "Carregando..."}</p>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}> <i class="fa fa-check" aria-hidden="true"></i>
 {d}</li>
                        ))
                      : "Carregando..."}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> <i class="fa fa-check" aria-hidden="true"></i>
  {d}</li>
                        ))
                      : "Carregando..."}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
